window.launchConfetti = function (originX, originY) {
    var canvas = document.createElement("canvas");
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    canvas.style.cssText = "position:fixed;top:0;left:0;pointer-events:none;z-index:2000";
    document.body.appendChild(canvas);
    var context = canvas.getContext("2d");
    var colors = ["bg-primary", "bg-success", "bg-warning", "bg-danger", "bg-info"].map(function (colorClass) {
        var $swatch = $("<div></div>").addClass(colorClass).appendTo("body");
        var color = $swatch.css("background-color");
        $swatch.remove();
        return color;
    });
    var pieces = [];
    for (var index = 0; index < 180; index++) {
        pieces.push({
            x: originX === undefined ? canvas.width / 2 : originX,
            y: originY === undefined ? canvas.height / 3 : originY,
            velocityX: (Math.random() - 0.5) * 26,
            velocityY: Math.random() * -20 - 4,
            size: 8 + Math.random() * 8,
            color: colors[index % colors.length],
            angle: Math.random() * Math.PI * 2,
            spin: (Math.random() - 0.5) * 0.4
        });
    }
    var startedAt = performance.now();
    var drawFrame = function (now) {
        context.clearRect(0, 0, canvas.width, canvas.height);
        pieces.forEach(function (piece) {
            piece.velocityY += 0.45;
            piece.velocityX *= 0.99;
            piece.x += piece.velocityX;
            piece.y += piece.velocityY;
            piece.angle += piece.spin;
            context.save();
            context.translate(piece.x, piece.y);
            context.rotate(piece.angle);
            context.fillStyle = piece.color;
            context.fillRect(-piece.size / 2, -piece.size / 4, piece.size, piece.size / 2);
            context.restore();
        });
        if (now - startedAt < 4000) {
            requestAnimationFrame(drawFrame);
            return;
        }
        canvas.remove();
    };
    requestAnimationFrame(drawFrame);
};
